"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ReportCancelButton = require("./ReportCancelButton");
Object.keys(_ReportCancelButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportCancelButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReportCancelButton[key];
    }
  });
});
var _EmailInput = require("./EmailInput");
Object.keys(_EmailInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmailInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmailInput[key];
    }
  });
});
var _ReasonInput = require("./ReasonInput");
Object.keys(_ReasonInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReasonInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ReasonInput[key];
    }
  });
});
